import React from 'react'
import clsx from 'clsx'
import withStyles from '@material-ui/core/styles/withStyles'

import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Container from '@material-ui/core/Container'
import Image from 'gatsby-image'
import Typography from '@material-ui/core/Typography'
import Section from '../../components/Section'
import useOurCausesImagesData from '../../hooks/ourCausesImages'
import styles from './OurCausesSection.styles'
import RegisterCTA from '../../components/RegisterCTA'
import propTypes from './propTypes'
import { isMobile } from '../../hooks/responsive'
import { enableElo } from '../../utils/enable-elo'

const PureOurCausesSection = ({
  classes,
  className,
  intl,
  langKey,
  ctaOnClick,
  isEloThemeActive,
  ...props
}) => {
  const data = useOurCausesImagesData()
  // eslint-disable-next-line no-console
  const getAmazonImage = () => {
    if (isEloThemeActive && langKey === 'es_PE') return data.amazonImagePE.childImageSharp.fluid
    if (isEloThemeActive && langKey === 'es_CO') return data.eloImageCOFirst.childImageSharp.fluid
    if (isEloThemeActive && langKey === 'es_CL') return data.eloImageCLFirst.childImageSharp.fluid

    if (langKey === 'en_MY') return data.amazonImageMY.childImageSharp.fluid
    return data.amazonImage.childImageSharp.fluid
  }

  const getPlasticOceanImage = () => {
    if (isEloThemeActive  && langKey === 'es_PE') return data.plasticOceanImagePE.childImageSharp.fluid
    if (isEloThemeActive  && langKey === 'es_CO') return data.eloImageCOSecond.childImageSharp.fluid
    if (isEloThemeActive  && langKey === 'es_CL') return data.eloImageCLSecond.childImageSharp.fluid
    if (langKey === 'en_MY') return data.plasticOceanImageMY.childImageSharp.fluid
    return data.plasticOceanImage.childImageSharp.fluid
  }
  const amazonImage = getAmazonImage()
  const plasticOceanImage = getPlasticOceanImage()
  return (
    <Section
      className={clsx(classes.root, className)}
      headingTitle={<FormattedMessage id="ourCausesHeadingTitle" />}
      headingSubtitle={<FormattedMessage id="ourCausesHeadingSubtitle" />}
      isEloThemeActive={isEloThemeActive}
      {...props}
    >
      <Container maxWidth="md">
        <Card classes={{ root: classes.card }}>
          <CardMedia
            classes={{ root: clsx(classes.cardMedia, classes.firstCardMedia) }}
          >
            <Image
              alt="Mulher negra sentada em um tronco de árvore acima de um rio no meio da Amazônia olhando para o horizonte."
              draggable={false}
              fluid={amazonImage}
            />
          </CardMedia>
          <CardContent classes={{ root: classes.cardContent }}>
            {!(isEloThemeActive && enableElo()) && <Typography
              classes={{ h3: classes.h3 }}
              component="h3"
              variant="h3"
            >
              <FormattedMessage id="ourCausesAmazonTitle" />
            </Typography>}
            <Typography classes={{ paragraph: classes.paragraph }} paragraph>
              <FormattedHTMLMessage id="ourCausesAmazonText" />
            </Typography>
          </CardContent>
        </Card>
        <Card classes={{ root: clsx(classes.card, classes.secondCard) }}>
          <CardMedia
            classes={{ root: clsx(classes.cardMedia, classes.secondCardMedia) }}
          >
            <Image
              alt="Imagem de oceano cuja superfície é feita com sacolas de plástico, dando ilusão de ser um mar, entre elas uma se destaca boiando."
              draggable={false}
              fluid={plasticOceanImage}
            />
          </CardMedia>
          <CardContent classes={{ root: classes.cardContent }}>
            {isEloThemeActive && enableElo() ? <div className={classes.spaceTop} /> : <Typography
              classes={{ h3: classes.h3 }}
              component="h3"
              variant="h3"
            >
              <FormattedMessage id="ourCausesRecyclingTitle" />
            </Typography>}
            <Typography classes={{ paragraph: classes.paragraph }} paragraph>
              <FormattedHTMLMessage id="ourCausesRecyclingText" />
            </Typography>
          </CardContent>
        </Card>
        <Typography
          classes={{ root: classes.callToAction }}
          align="center"
          paragraph
          component="h2"
        >
          <RegisterCTA
            id="our-causes-register-cta-button"
            data-gtm-category="landing_nossas_causas"
            data-gtm-label={intl.formatMessage({
              id: 'benefitRegisterButtonText'
            })}
            data-gtm-main-action="click"
            data-gtm-category-ga4="landing_our_causes"
            data-gtm-label-ga4={intl.formatMessage({ id: 'benefitRegisterButtonText' })}
            data-gtm-main-action-ga4="click"
            data-testid="our-causes-register-cta-button"
            label={intl.formatMessage({ id: 'benefitRegisterButtonText' })}
            href={isMobile() ? (
              intl.formatMessage({ id: 'ctaButtonLinkMobile' })
            ) : (
              intl.formatMessage({ id: 'ctaButtonLinkDesktop' })
            )}
            onClick={ctaOnClick}
            isEloThemeActive={isEloThemeActive}
          />
        </Typography>
      </Container>
    </Section>
  )
}

PureOurCausesSection.propTypes = propTypes

const OurCausesSection = withStyles(styles)(injectIntl(PureOurCausesSection))

export default OurCausesSection
